import tailSelect from 'tail.select.js'

export const initTailSelect = (): void => {
  const $selectElements = document.querySelectorAll<HTMLSelectElement>("select[name='table-filter']")
  if ($selectElements) {
    tailSelect($selectElements, { search: false, deselect: false, classNames: 'select-container' })
    $selectElements.forEach(($selectElement) => {
      $selectElement.addEventListener('change', (event: Event) => {
        const selectedValue = (event.target as HTMLSelectElement).value
        if (selectedValue) {
          const $allElements = document.querySelectorAll<HTMLTableColElement>('[data-row-table]')
          $allElements.forEach((el: HTMLTableColElement) => {
            el.classList.remove('foreign-transfers-types__table-td--active')
          })
          const $activeElements = document.querySelectorAll<HTMLTableColElement>(`[data-row-${selectedValue}]`)
          $activeElements.forEach((el) => {
            el.classList.add('foreign-transfers-types__table-td--active')
          })
        } else {
          console.warn('No value selected in the dropdown.')
        }
      })
    })
  } else {
    console.error("Item not found select name 'table-filter'")
  }
}
